import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper';
import EFPicture from '@elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

let maskScene: any = null;
export default function T() {
    const { useLang, useRouter, useEffect, useState, gtm, Link } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('delta_pro_ultra.launch.detail');
    const [gap, setGap] = useState(24);
    const [textEnter, setTextEnter] = useState(false);
    const LOCAL_SITES: string[] = ['jp'];

    const cards: any[] = [
        {
            img: '/responsive/picture/delta-pro-ultra/launch/20_1',
            text: t('secT_card1_text'),
        },
        {
            img: LOCAL_SITES?.includes(locale)
                ? `/responsive/picture/delta-pro-ultra/launch/20_2_${locale}`
                : '/responsive/picture/delta-pro-ultra/launch/20_2',
            text: t('secT_card2_text'),
            tip: ['us', 'ca']?.includes(locale) ? '*Please use a grounding adapter when you charge the EV.' : '',
        },
        {
            img: LOCAL_SITES?.includes(locale)
                ? `/responsive/picture/delta-pro-ultra/launch/20_3_${locale}`
                : '/responsive/picture/delta-pro-ultra/launch/20_3',
            text: t('secT_card3_text'),
        },
    ];

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const resize = () => setGap(window?.innerWidth > 1024 ? 24 : 12);
            resize();
            //window?.addEventListener('resize', resize);
            //return () => window.removeEventListener('resize', resize);
        }
    }, []);

    useEffect(() => {
        const resizeAni = () => {
            if (maskScene) AniContainer.removeScene(maskScene);

            const clientH = (window.innerHeight || 0) * 0.2;
            const startH = Math.min(clientH, 150);
            maskScene = AniContainer.create({
                triggerElement: '.dpu-detail-T',
                triggerHook: 1,
                offset: startH,
                duration: 200, //window.innerHeight * 2,
                onEnter: () => {
                    setTextEnter(true);
                },
                //onLeave: () => setTextEnter(false),
            });
        };
        resizeAni();
    }, []);

    return (
        <section className={`dpu-detail-T dpu-detail-section ${textEnter ? 'textEnter' : ''} ${css['dpu-detail-T']}`}>
            <h2 className="title">{t('secT_title')}</h2>
            <Swiper className="cards swiper-box" modules={[Navigation]} spaceBetween={gap} slidesPerView={'auto'} initialSlide={0} navigation={true}>
                {cards?.map((card: any, k: number) => (
                    <SwiperSlide className={`swiper-item item-${k + 1}`} key={k}>
                        <EFPicture src={`${card?.img}.jpg`} srcPad={`${card?.img}_768.jpg`} srcMobile={`${card?.img}_768.jpg`} alt={card?.text} />
                        <p className={`card-text ${k === 1 ? 'black' : ''}`}>{card?.text}</p>
                        {card?.tip && <p className="card-tip">{card?.tip}</p>}
                    </SwiperSlide>
                ))}
            </Swiper>
        </section>
    );
}
